export class ToggleDeviceLoader {
  static readonly type = '[Loader] Toggle device loader';

  constructor(public value: boolean) {
  }
}

export class ToggleUnapprovedLoader {
  static readonly type = '[Loader] Toggle unapproved device loader';

  constructor(public value: boolean) {
  }
}

export class ToggleGroupsLoader {
  static readonly type = '[Loader] Toggle groups loader';

  constructor(public value: boolean) {
  }
}

export class ToggleMediaLoader {
  static readonly type = '[Loader] Toggle media loader';

  constructor(public value: boolean) {
  }
}

export class TogglePlaylistLoader {
  static readonly type = '[Loader] Toggle playlist loader';

  constructor(public value: boolean) {
  }
}

export class ToggleScheduleLoader {
  static readonly type = '[Loader] Toggle schedule loader';

  constructor(public value: boolean) {
  }
}

export class ToggleGlobalLoader {
  static readonly type = '[Loader] Toggle global loader';

  constructor(public value: boolean) {
  }
}

export class ToggleMetricsLoader {
  static readonly type = '[Loader] Toggle metrics dashboard loader';

  constructor(public value: boolean) {
  }
}

export class ToggleOfflineDevicesSummaryLoader {
  static readonly type = '[Loader] Toggle offline devices summary loader';

  constructor(public value: boolean) {
  }
}

export class ToggleUngroupedDevicesLoader {
  static readonly type = '[Loader] Toggle ungrouped devices loader';

  constructor(public value: boolean) {
  }
}

export class ToggleGroupedDevicesLoader {
  static readonly type = '[Loader] Toggle grouped devices loader';

  constructor(public value: boolean) {
  }
}

export class ToggleScheduledGroupsLoader {
  static readonly type = '[Loader] Toggle scheduled groups loader';

  constructor(public value: boolean) {
  }
}

export class ToggleScheduledDevicesLoader {
  static readonly type = '[Loader] Toggle scheduled devices loader';

  constructor(public value: boolean) {
  }
}

export class ToggleRssLoader {
  static readonly type = '[Loader] Toggle RSS loader';

  constructor(public value: boolean) {
  }
}

export class ToggleSettingsLoader {
  static readonly type = '[Loader] Toggle Settings loader';

  constructor(public value: boolean) {
  }
}
